<div>
  <div  class="separator" style="margin-top: 1px; margin-right: 30px; margin-left: 15px"> </div>
  <li style="margin-top: 13px;">
    <div style="margin-top: 15px"> </div>
    <a class="nav-title"> {{title.name | translate}}</a>
  </li>
  <div  style="margin-bottom: 9px"> </div>
</div>

